import React from 'react';
import './css/popupstyle.css';

class Popup extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            wname: this.props.wholesaler_name,
        };
    }
    render() {
        console.log(this.state.wname);
        let baseurl = "https://cnd.23byt.es/home/index?wholeseller=";
        if (this.state.wname == "Avenel") {
            baseurl = "https://cnd.23byt.es/home/savenel?wholeseller=";
            console.log(baseurl);
        }
        else {
            baseurl = "https://cnd.23byt.es/home/usindex?wholeseller=";
        }
        return (
            <div className='popup manage-scroll'>
                <div className='popup_inner'>
                    <h1>{this.props.text}<button onClick={this.props.SubDisclosePopup}>X</button></h1>
                    <iframe src={baseurl + this.state.wname} />
                </div>
            </div>
        );
    }
}


export default Popup;